function secondSlider() {
    $('.js-second-slider__slide').each(function(){
      $(this).css('z-index',$(this).attr('data-ind'));
    })
    var most = $('.js-second-slider__slide').first().data('ind');
    if($(document).width() < 1184) {
      $('.js-second-slider__slide').css('width','0%');
      $('.js-second-slider__slide.second-slider__slide-active').css('width','100%');
    } else {
      $('.js-second-slider__slide').css('width',((1184-734)/most)+'px');
      $('.second-slider__slide-prewiev').css('width',((1184-734)/most)+'px');
      $('.js-second-slider__slide.second-slider__slide-active').css('width','734px');
    }
    $('.js-second-slider__mobile-dot').each(function(){
      if ($(this).data('ind') > most) {
        $(this).css('display','none');
      }
    })
    var newTime = setTimeout(function(){slider();},5000);
    function slider(index) {
      if (index) {
        var act = index;
      } else {
        var act = $('.second-slider__slide-active').attr('data-ind');
      }
      $('.js-second-slider__slide').removeClass('second-slider__slide-active');
      $('.js-second-slider__slide').removeClass('second-slider__slide-inactive');
      $('.js-second-slider__mobile-dot').removeClass('second-slider__mobile-dotactive');
      if (Number(act) == most) {
      $('.js-second-slider__slide').each (function() {
        if ($(this).attr('data-ind') == 0) {
          $(this).addClass('second-slider__slide-active');
          $(this).css('z-index',5);
        } else if ($(this).attr('data-ind') > 0) {
          $(this).css('z-index',$(this).attr('data-ind'));
        }
        $('.js-second-slider__mobile-dot[data-ind="0"]').addClass('second-slider__mobile-dotactive');
      })
      } else if (act != 0) {
      $('.js-second-slider__slide').each (function() {
        if ($(this).attr('data-ind') < Number(act) + 1) {
          $(this).addClass('second-slider__slide-inactive');
          $(this).css('z-index',$(this).attr('data-ind'));
        } else if ($(this).attr('data-ind') == Number(act) + 1) {
          $(this).addClass('second-slider__slide-active');
          $(this).css('z-index',5);
        } else if ($(this).attr('data-ind') < Number(act)) {
          $(this).css('z-index',$(this).attr('data-ind'));
        }
        $('.js-second-slider__mobile-dot[data-ind="'+(Number(act)+1)+'"]').addClass('second-slider__mobile-dotactive');
      })
      }  else {
      $('.js-second-slider__slide').each (function() {
      if ($(this).attr('data-ind') == 1) {
        $(this).addClass('second-slider__slide-active');
        $(this).css('z-index',5);
      } else if ($(this).attr('data-ind') > 1) {
        $(this).css('z-index',$(this).attr('data-ind'));
      }
    })
    $('.js-second-slider__mobile-dot[data-ind="1"]').addClass('second-slider__mobile-dotactive');
    }
    newTime = setTimeout(function(){slider();},5000);
    if($(document).width() < 1184) {
      $('.js-second-slider__slide').css('width','0%');
      $('.js-second-slider__slide.second-slider__slide-active').css('width','100%');
    } else {
      $('.js-second-slider__slide').css('width',((1184-734)/most)+'px');
      $('.second-slider__slide-prewiev').css('width',((1184-734)/most)+'px');
      $('.js-second-slider__slide.second-slider__slide-active').css('width','734px');
    }
  }
  $('.js-second-slider__slide').click(function() {
    if (!$(this).hasClass('second-slider__slide-active')) {
    $('.js-second-slider__slide').removeClass('second-slider__slide-active');
    $('.js-second-slider__slide').removeClass('second-slider__slide-inactive');
    var ind = $(this).attr('data-ind');
    $('.js-second-slider__slide').each (function() {
      if ($(this).attr('data-ind') < ind) {
        $(this).addClass('second-slider__slide-inactive');
        $(this).css('z-index',$(this).attr('data-ind'));
      } else if ($(this).attr('data-ind') == ind) {
        $(this).addClass('second-slider__slide-active');
        $(this).css('z-index',$(this).attr('data-ind'));
      } else if ($(this).attr('data-ind') > ind) {
        $(this).css('z-index',$(this).attr('data-ind'));
      }
    })
    if($(document).width() < 1184) {
      $('.js-second-slider__slide').css('width','0%');
      $('.js-second-slider__slide.second-slider__slide-active').css('width','100%');
    } else {
      $('.js-second-slider__slide').css('width',((1184-734)/most)+'px');
      $('.second-slider__slide-prewiev').css('width',((1184-734)/most)+'px');
      $('.js-second-slider__slide.second-slider__slide-active').css('width','734px');
    }
    clearTimeout(newTime);
    newTime = setTimeout(function(){slider();},5000);
  }
})
$('.js-second-slider__slide').click(function(){
  if($(document).width() < 1184) {
    clearTimeout(newTime);
    setTimeout(function(){slider();},0);
    $('.js-second-slider__slide').css('width','0%');
    $('.js-second-slider__slide.second-slider__slide-active').css('width','100%');
  }
})
  $('.js-second-slider__mobile-dot').click(function() {
    if (!$(this).hasClass('second-slider__mobile-dotactive')) {
    $('.js-second-slider__slide').removeClass('second-slider__slide-active');
    $('.js-second-slider__slide').removeClass('second-slider__slide-inactive');
    $('.js-second-slider__mobile-dot').removeClass('second-slider__mobile-dotactive');
    $(this).addClass('second-slider__mobile-dotactive');
    var ind = $(this).attr('data-ind');
    $('.js-second-slider__slide').each (function() {
      if ($(this).attr('data-ind') < ind) {
        $(this).addClass('second-slider__slide-inactive');
        $(this).css('z-index',$(this).attr('data-ind'));
      } else if ($(this).attr('data-ind') == ind) {
        $(this).addClass('second-slider__slide-active');
        $(this).css('z-index',$(this).attr('data-ind'));
      } else if ($(this).attr('data-ind') > ind) {
        $(this).css('z-index',$(this).attr('data-ind'));
      }
    })
    clearTimeout(newTime);
    newTime = setTimeout(function(){slider();},5000);
      $('.js-second-slider__slide').css('width','0%');
      $('.js-second-slider__slide.second-slider__slide-active').css('width','100%');
  }
  })
}

export {
  secondSlider
}
